const numberFormat = new Intl.NumberFormat("en-AU", { maximumFractionDigits: 1 });

export const formatValue = (value: number, unit?: string) =>
  `${numberFormat.format(value)}${unit ?? ""}`;

/** Round tick values for an axis from `min` to `max` (inclusive of 0 when the data allows). */
export const niceTicks = (min: number, max: number, count = 4): number[] => {
  const low = Math.min(0, min);
  const high = max === low ? low + 1 : max;
  const rough = (high - low) / count;
  const magnitude = 10 ** Math.floor(Math.log10(rough));
  const step = [1, 2, 2.5, 5, 10].map((m) => m * magnitude).find((s) => s >= rough) ?? rough;
  const start = Math.floor(low / step) * step;
  const ticks: number[] = [];
  for (let tick = start; tick <= high + step * 0.999; tick += step) {
    ticks.push(Number(tick.toFixed(10)));
  }
  return ticks;
};
